import { put,getContext} from "redux-saga/effects";
import importer from "common/importer";
const { getLoyaltyMilestones } = importer("GraphQL/Queries");
const PublicContentActions = importer("Stores/PublicContent/Actions");

import i18next from "i18next";

export default function* main({sfid}) {
  try {
    const isSpanish = i18next.language === "es-MX";
    yield put(PublicContentActions.getLoyaltyMilestonesLoading());
    const apolloClient = yield getContext('client')
    const query = getLoyaltyMilestones;
    const { data, error } = yield apolloClient.query({
      query,
      variables: { isSpanish: isSpanish, sfid: sfid},
    });
    if (error) {
      throw error;
    }
    const loyaltyMilestones = data.salesforce_bll_milestone__c;
    yield put(
      PublicContentActions.getLoyaltyMilestonesSuccess(loyaltyMilestones)
    );
  } catch (error) {
    yield put(PublicContentActions.getLoyaltyMilestonesFailure(error));
  }
}
